<template>
    <ion-grid :style="backgroundStyle" class="banner-grid" data-cy="promo-area">
        <ion-row :class="isPortraitOrientation ? 'stacked-content-blocks' : 'content-blocks'">
            <promoBlock :promoBlock="firstBlock" whichBlock="firstBlock" />
            <promoBlock :promoBlock="secondBlock" whichBlock="secondBlock" />
        </ion-row>
    </ion-grid>
</template>
<script lang="ts">
import { computed, defineComponent } from 'vue';
import { useStore } from 'vuex';
import PromoBlock from '@/components/promoBlock.vue';
import { PromoBlockModel } from '@/models/PromoBlockModel';
import { Promo } from '@/models/promo';
import { IonGrid, IonRow } from '@ionic/vue';

export default defineComponent({
    props: {
        promo: Promo,
    },
    setup(props) {
        const store = useStore();
        const isMobile = computed(() => store.getters.isMobile);
        const isPortraitOrientation = computed(() => store.getters.isPortraitOrientation);

        const firstBlock = computed(() => new PromoBlockModel(props.promo?.firstBlock));
        const secondBlock = computed(() => new PromoBlockModel(props.promo?.secondBlock));

        return { isMobile, isPortraitOrientation, firstBlock, secondBlock };
    },
    components: { IonGrid, IonRow, PromoBlock },
    computed: {
        backgroundStyle() {
            return `
      background-image: url(${this.promo?.cdnImg(this.isPortraitOrientation)});
      background-size: cover;
      height: 80%;
      background-repeat: no-repeat;
      background-position: center;
      `;
        },
    },
});
</script>

<style scoped>
.banner-grid {
    color: white;
    min-height: 400px;
}

ion-row {
    height: 100%;
}

ion-grid {
    padding: unset;
}

.content-block-1,
.content-block-2 {
    padding: 20px 20px;
    max-width: 700px;
}

.ion-col {
    display: flex;
    align-items: center;
    padding: unset;
}

.stacked-content-blocks > .ion-col {
    /*height: 50%;*/
}

#first-promo .stacked-content-blocks > .ion-col {
    height: 64%;
}
</style>
